
import { useEffect, useState } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import RefundForm from '../home/components/RefundForm';

export default function EventPage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <Navbar scrolled={scrolled} />
      
      {/* Hero Section with Brand Image */}
      <section className="relative pt-20 sm:pt-24 pb-10 sm:pb-20">
        <div className="absolute inset-0 overflow-hidden">
          <img
            src="https://public.readdy.ai/ai/img_res/3ea662f19a61f80a5aa1701cdb92cc5c.jpg"
            alt="LEXO Event"
            className="w-full h-full object-cover object-center opacity-40"
            crossOrigin="anonymous"
            onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A]/60 via-[#0A0A0A]/80 to-[#0A0A0A]"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 text-center">
          <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-1.5 sm:py-2 bg-teal-500/10 backdrop-blur-sm rounded-full mb-3 sm:mb-6">
            <i className="ri-gift-line text-[14px] sm:text-[16px] text-teal-400"></i>
            <span className="text-[11px] sm:text-[13px] font-semibold text-teal-400">진행 중인 이벤트</span>
          </div>
          <h1 className="text-[36px] sm:text-[60px] md:text-[80px] font-bold text-white mb-2 sm:mb-4 leading-tight tracking-tight">
            LEXO 환급 이벤트
          </h1>
          <p className="text-base sm:text-xl md:text-2xl font-bold text-teal-400 mb-3 sm:mb-6">
            🔥 히어로를 찾아라!
          </p>
          <p className="text-[13px] sm:text-[17px] text-gray-400 leading-relaxed max-w-2xl mx-auto">
            Personal 플랜 구매 후 숙제를 완수하고<br />
            SNS 인증하면 매달 10%에게 ₩20,000 환급
          </p>
        </div>
      </section>

      {/* Event Details */}
      <section className="py-12 sm:py-20 px-4 sm:px-6">
        <div className="max-w-5xl mx-auto">
          {/* Main Event Card */}
          <div className="bg-gradient-to-br from-teal-500 to-cyan-500 rounded-2xl sm:rounded-3xl p-6 sm:p-12 mb-12 sm:mb-16 relative overflow-hidden">
            <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS1vcGFjaXR5PSIwLjA1IiBzdHJva2Utd2lkdGg9IjEiLz48L3BhdHRlcm4+PC9kZWZzPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjZ3JpZCkiLz48L3N2Zz4=')] opacity-30"></div>
            
            <div className="relative z-10 text-center">
              <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-1.5 sm:py-2 bg-white/20 backdrop-blur-sm rounded-full mb-4 sm:mb-6">
                <span className="text-[11px] sm:text-[13px] font-semibold text-white">매달 10% 추첨</span>
              </div>
              <h2 className="text-[28px] sm:text-[40px] font-bold text-white mb-3 sm:mb-4">
                ₩20,000 환급 이벤트
              </h2>
              <p className="text-[13px] sm:text-[18px] text-white/90 mb-6 sm:mb-8">
                Personal 플랜 구매 후 숙제를 완수하고<br />
                SNS에 인증하면 매달 완수자 중 10%를 추첨하여 환급해드립니다
              </p>
              <div className="flex items-center justify-center gap-4 sm:gap-8 pt-4 sm:pt-6 border-t border-white/20">
                <div className="text-center">
                  <div className="text-[20px] sm:text-[32px] font-bold text-white mb-0.5 sm:mb-1">₩20,000</div>
                  <div className="text-[10px] sm:text-[14px] text-white/80">환급 금액</div>
                </div>
                <div className="w-px h-8 sm:h-12 bg-white/20"></div>
                <div className="text-center">
                  <div className="text-[20px] sm:text-[32px] font-bold text-white mb-0.5 sm:mb-1">10%</div>
                  <div className="text-[10px] sm:text-[14px] text-white/80">추첨 비율</div>
                </div>
                <div className="w-px h-8 sm:h-12 bg-white/20"></div>
                <div className="text-center">
                  <div className="text-[20px] sm:text-[32px] font-bold text-white mb-0.5 sm:mb-1">매달</div>
                  <div className="text-[10px] sm:text-[14px] text-white/80">추첨 주기</div>
                </div>
              </div>
            </div>
          </div>

          {/* How It Works */}
          <div className="mt-8 sm:mt-0 mb-12 sm:mb-16">
            <h3 className="text-[24px] sm:text-[32px] font-bold text-white mb-6 sm:mb-8 text-center">참여 방법</h3>
            <div className="grid grid-cols-3 gap-2 sm:gap-6">
              <div className="bg-[#0F0F0F] border border-gray-800 rounded-xl sm:rounded-2xl p-3 sm:p-8 text-center">
                <div className="w-10 h-10 sm:w-16 sm:h-16 bg-teal-500/10 rounded-full flex items-center justify-center mx-auto mb-2 sm:mb-4">
                  <i className="ri-shopping-bag-line text-[18px] sm:text-[28px] text-teal-400"></i>
                </div>
                <h4 className="text-[12px] sm:text-[20px] font-bold text-white mb-1 sm:mb-3">플랜 구매</h4>
                <p className="text-[9px] sm:text-[14px] text-gray-400 leading-relaxed hidden sm:block">
                  LEXO Personal 플랜을<br />
                  구매하고<br />
                  학습을 시작하세요
                </p>
              </div>

              <div className="bg-[#0F0F0F] border border-gray-800 rounded-xl sm:rounded-2xl p-3 sm:p-8 text-center">
                <div className="w-10 h-10 sm:w-16 sm:h-16 bg-teal-500/10 rounded-full flex items-center justify-center mx-auto mb-2 sm:mb-4">
                  <i className="ri-file-text-line text-[18px] sm:text-[28px] text-teal-400"></i>
                </div>
                <h4 className="text-[12px] sm:text-[20px] font-bold text-white mb-1 sm:mb-3">숙제 완수</h4>
                <p className="text-[9px] sm:text-[14px] text-gray-400 leading-relaxed hidden sm:block">
                  제공되는<br />
                  모든 숙제를<br />
                  성실히 완수하세요
                </p>
              </div>

              <div className="bg-[#0F0F0F] border border-gray-800 rounded-xl sm:rounded-2xl p-3 sm:p-8 text-center">
                <div className="w-10 h-10 sm:w-16 sm:h-16 bg-teal-500/10 rounded-full flex items-center justify-center mx-auto mb-2 sm:mb-4">
                  <i className="ri-share-line text-[18px] sm:text-[28px] text-teal-400"></i>
                </div>
                <h4 className="text-[12px] sm:text-[20px] font-bold text-white mb-1 sm:mb-3">SNS 인증</h4>
                <p className="text-[9px] sm:text-[14px] text-gray-400 leading-relaxed hidden sm:block">
                  숙제 완수 인증샷을<br />
                  SNS에 올리고<br />
                  신청서를 제출하세요
                </p>
              </div>
            </div>
          </div>

          {/* Benefits */}
          <div className="bg-[#0F0F0F] border border-gray-800 rounded-xl sm:rounded-2xl p-6 sm:p-10 mb-12 sm:mb-16">
            <h3 className="text-[20px] sm:text-[28px] font-bold text-white mb-4 sm:mb-6 text-center">환급 혜택</h3>
            <div className="space-y-3 sm:space-y-4">
              <div className="flex items-start gap-3 sm:gap-4">
                <div className="w-6 h-6 sm:w-8 sm:h-8 bg-teal-500/10 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 sm:mt-1">
                  <i className="ri-check-line text-[14px] sm:text-[18px] text-teal-400"></i>
                </div>
                <div>
                  <h4 className="text-[14px] sm:text-[18px] font-semibold text-white mb-1 sm:mb-2">₩20,000 환급</h4>
                  <p className="text-[11px] sm:text-[14px] text-gray-400 leading-relaxed">
                    매달 숙제 완수자 중 10%를 추첨하여 ₩20,000을 환급해드립니다
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3 sm:gap-4">
                <div className="w-6 h-6 sm:w-8 sm:h-8 bg-teal-500/10 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 sm:mt-1">
                  <i className="ri-check-line text-[14px] sm:text-[18px] text-teal-400"></i>
                </div>
                <div>
                  <h4 className="text-[14px] sm:text-[18px] font-semibold text-white mb-1 sm:mb-2">빠른 처리</h4>
                  <p className="text-[11px] sm:text-[14px] text-gray-400 leading-relaxed">
                    추첨 결과 발표 후 7일 이내에 환급 처리됩니다
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3 sm:gap-4">
                <div className="w-6 h-6 sm:w-8 sm:h-8 bg-teal-500/10 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 sm:mt-1">
                  <i className="ri-check-line text-[14px] sm:text-[18px] text-teal-400"></i>
                </div>
                <div>
                  <h4 className="text-[14px] sm:text-[18px] font-semibold text-white mb-1 sm:mb-2">매달 기회</h4>
                  <p className="text-[11px] sm:text-[14px] text-gray-400 leading-relaxed">
                    매달 새로운 추첨 기회가 제공되어 여러 번 도전할 수 있습니다
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Important Notes */}
          <div className="bg-amber-500/5 border border-amber-500/20 rounded-xl sm:rounded-2xl p-5 sm:p-8 mb-12 sm:mb-16">
            <div className="flex items-start gap-3 sm:gap-4">
              <i className="ri-information-line text-[20px] sm:text-[24px] text-amber-400 flex-shrink-0 mt-0.5 sm:mt-1"></i>
              <div>
                <h4 className="text-[16px] sm:text-[20px] font-bold text-white mb-3 sm:mb-4">유의사항</h4>
                <ul className="space-y-1.5 sm:space-y-2 text-[11px] sm:text-[14px] text-gray-300">
                  <li className="flex items-start gap-2">
                    <span className="text-amber-400 mt-0.5 sm:mt-1">•</span>
                    <span>본 이벤트는 Personal 플랜 구매자에게만 적용됩니다</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-amber-400 mt-0.5 sm:mt-1">•</span>
                    <span>제공되는 모든 숙제를 완수해야 추첨 대상이 됩니다</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-amber-400 mt-0.5 sm:mt-1">•</span>
                    <span>SNS 인증은 공개 게시물로 올려야 합니다</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-amber-400 mt-0.5 sm:mt-1">•</span>
                    <span>매달 말일에 추첨, 익월 초 결과 발표</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-amber-400 mt-0.5 sm:mt-1">•</span>
                    <span>환급은 신청자 명의의 계좌로만 가능합니다</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-amber-400 mt-0.5 sm:mt-1">•</span>
                    <span>중복 당첨 불가, 한 달에 한 번만 당첨 가능</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 강한 일본어 Slogan Banner */}
      <section className="py-14 sm:py-24 px-4 sm:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="relative rounded-2xl sm:rounded-3xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Dramatic%20intense%20Japanese%20language%20learning%20motivation%20banner%20with%20powerful%20explosive%20fire%20flames%20and%20energy%20bursts%20featuring%20bold%20strong%20red%20crimson%20scarlet%20color%20scheme%20with%20dynamic%20flame%20particles%20embers%20and%20dramatic%20lighting%20effects%20emphasizing%20strength%20power%20and%20passion%20with%20text%20space%20for%20strong%20Japanese%20slogan%20professional%20education%20design&width=1400&height=600&seq=lexo-strong-japanese-red-fire-003&orientation=landscape"
              alt="강한 일본어"
              className="w-full h-[300px] sm:h-[600px] object-cover object-center"
              crossOrigin="anonymous"
              onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4 sm:px-6">
              <div className="inline-block bg-red-600/90 backdrop-blur-sm text-white px-5 sm:px-8 py-2 sm:py-3 rounded-full text-[11px] sm:text-sm font-bold mb-4 sm:mb-8 border-2 border-red-400 whitespace-nowrap">
                LEXO의 약속
              </div>
              <h2 className="text-[36px] sm:text-6xl md:text-8xl font-black text-white mb-3 sm:mb-6 drop-shadow-2xl">
                강한 일본어
              </h2>
              <p className="text-[14px] sm:text-2xl md:text-3xl text-white font-bold mb-4 sm:mb-8 drop-shadow-lg">
                진짜 실력으로 승부하는 일본어 학습
              </p>
              <button className="bg-red-600 hover:bg-red-700 text-white font-bold px-8 sm:px-12 py-3 sm:py-5 rounded-xl text-[13px] sm:text-lg transition-all duration-300 shadow-2xl border-2 border-red-400 whitespace-nowrap cursor-pointer">
                지금 시작하기
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Refund Application Form */}
      <div className="mt-6 sm:mt-10">
        <RefundForm />
      </div>

      <Footer />
    </div>
  );
}
